export function batch(callback) {
  var calls = [];
  return function () {
    if (calls.length === 0) {
      window.setTimeout(function () {
        callback(calls);
        calls = [];
      });
      calls = [];
    }
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    calls.push(args);
  };
}
export function batchByKey(callback) {
  var calls = {};
  return function (key) {
    if (!calls[key]) {
      window.setTimeout(function () {
        callback(key, calls[key]);
        delete calls[key];
      });
      calls[key] = [];
    }
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }
    calls[key].push(args);
  };
}